import { useCentrixApi } from "core/hooks/useCentrixApi";
import { useLocale } from "core/hooks/useLocale";

export function useNewsEventCategories(isFeatured?: boolean) {
  const locale = useLocale();
  return useCentrixApi({
    path: "/api/news-events/categories/CategoriesSummaries",
    parameters: {
      query: {
        Aggregation: "category",
        Locale: locale,
        IsFeatured: isFeatured,
      },
    },
  });
}
